module.exports = __webpack_public_path__ + "img/kookieskakes.8f027218.svg";